export const featureFlagsArray = [
    'big-app-dark-mode',
    'big-app-form-state',
    'big-app-global-error-tracking',
    'big-cookiebot-without-styles',
] as const;

export type FeatureFlags = (typeof featureFlagsArray)[number];
